import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, rem, useBreakpointValue } from '@bonusly/design-system';
import { useDispatch } from '@bonusly/events';
import { useAnalytics, useCurrentCompany, useCurrentUser, useFeatureFlag } from '@bonusly/who-am-i';

import { CompanyStatus } from '../../types/company';
import { InviteUsersCTANavButton } from './InviteUsersCTANavButton';

export function InviteUsers() {
	const { t } = useTranslation('navigation', { keyPrefix: 'invite_dropdown' });
	const user = useCurrentUser();
	const company = useCurrentCompany();
	const { track } = useAnalytics();
	const dispatch = useDispatch();
	const inviteText = useBreakpointValue({
		xl: 'invite_teammates',
		base: 'invite',
	});
	const showFullButton = useBreakpointValue({ md: true, base: false });

	const onInviteByMailClick = useCallback(() => {
		track('Dropdown: Invite by Email');
		dispatch('open-user-invite-modal');
	}, [dispatch, track]);

	if (!user?.admin || company.status !== CompanyStatus.InTrial || company.is_demo) {
		return null;
	}

	return showFullButton ? (
		<Box
			as="button"
			alignItems="center"
			aria-label={t('invite_teammates')}
			border="1px solid"
			borderColor="blue.500"
			borderRadius="md"
			color="gray.700"
			data-testid="invite-users-cta"
			fontSize={{ base: '2xl', xs: 'lg' }}
			fontWeight="medium"
			h={rem(44)}
			onClick={onInviteByMailClick}
			px={{ base: 2, sm: 4 }}
			w={{ base: rem(44), sm: 'auto' }}
			_hover={{
				backgroundColor: 'blue.50',
			}}
		>
			{t(`${inviteText}`)}
		</Box>
	) : (
		<InviteUsersCTANavButton data-testid="invite-users-cta" />
	);
}
